import { formatPriceAmount } from "../../../utils/numbers"
import { TableCustomer } from "../../tables/transactions-table/data/types"
import SlidingCard from "../../ui/sliding-card"
import { Heading2, Heading5, Heading6 } from "../../ui/texts/TextStyle"
import BodyBlock from "../payment-modal/body/BodyBlock"
import BodyItem from "../payment-modal/body/BodyItem"

interface CustomerModalProps {
	open: boolean
	onClose: () => void
	customer: TableCustomer
}

const CustomerModal = ({ open, onClose, customer }: CustomerModalProps) => {
	if (!open) return null

	return (
		<SlidingCard
			open={open}
			onOpenChange={(open) => {
				if (!open) onClose()
			}}
			side="right"
		>
			<div className="p-6">
				<div className="flex flex-col bg-background-subtle mb-6 border border-border p-md rounded-md gap-betweenComponents">
					<div className="flex flex-row items-center text-text">
						<div className="flex flex-col">
							<Heading5 className="font-medium pb-[4px]">
								{customer.name || customer.alias}
							</Heading5>
							<Heading6 className="text-text-muted font-medium">
								Cliente ID: {customer.customer_id}
							</Heading6>
						</div>
					</div>
				</div>

				<div className="grid grid-cols-1 items-center">
					<BodyBlock title="Información General">
						<BodyItem
							name="Fecha de creación"
							value={customer.creationDateTime?.formatted.date}
						/>
						<BodyItem
							name="Hora de creación"
							value={customer.creationDateTime?.formatted.time}
						/>
						<div className="flex justify-between items-center py-betweenComponents">
							<Heading6 className="font-medium text-text-muted">
								Balance
							</Heading6>
							<div className="flex-col mb-2">
								<div className="flex justify-end">
									<Heading2 className="font-medium">
										{formatPriceAmount(customer.balance) || 0} ARS
									</Heading2>
								</div>
							</div>
						</div>
					</BodyBlock>

					<BodyBlock title="Información Bancaria">
						<BodyItem
							name="Alias"
							value={customer.bank_info.alias}
							copy={true}
						/>
						<BodyItem
							name="CVU"
							value={customer.bank_info.cvu}
							copy={true}
							overflow={true}
						/>
					</BodyBlock>
				</div>
			</div>
		</SlidingCard>
	)
}

export default CustomerModal
